import common from '../utils/common'
export default{
    nameFilter:(name)=>{
        if(name){
            if (name.match(/^手机用户1[3|4|5|7|8]\d{9}$/)){// || name.match(/^手机用户8869\d{8}$/) || name.match(/^手机用户852[5|6|9]\d{7}$/)
                return '手机用户';
            }
            if (name.match(/^手機用戶1[3|4|5|7|8]\d{9}$/)){// || name.match(/^手機用戶8869\d{8}$/) || name.match(/^手機用戶852[5|6|9]\d{7}$/)
                return '手機用戶';
            }
        }
        return name;
    },
    nameLong:(name,max=15)=>{
        if(name){
            if(common.getByteLen(name)<=max){
                return name;
            }else{
                return name.substr(0,common.getByteLen(name,max))+"...";
            }
        }
        return name;
    },
    timeFormat:(value)=>{
        let result = null;
        let year = "";
        let month = "";
        let day = "";
        let hour = "";
        let minute = "";
        let unyear = "";
        if((result=/\d{4}-\d{1,2}-\d{1,2}/g.exec(value)) != null){
            unyear = result[0];
            let time = unyear.split("-");
            year = time[0];
            month = time[1];
            day = time[2];
        }
        if((result=/\d{1,2}:\d{1,2}/g.exec(value)) != null){
            let time = result[0].split(":");
            hour = time[0];
            minute = time[1];
        }
        if(year==new Date().getFullYear()){
            if(month-1==new Date().getMonth() && day==new Date().getDate()){
                if(hour==new Date().getHours()){
                    if(minute==new Date().getMinutes()){
                        return "刚刚";
                    }else{
                        return new Date().getMinutes()-minute+"分钟前";
                    }
                }else{
                    return new Date().getHours()-hour+"小时前";
                }
            }else{
                return month+"-"+day+" "+hour+":"+minute;
            }
        }else if(!unyear){
            return unyear;
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/plugins/name.filter.js